import React from 'react';
import styled from 'styled-components/macro';
import { device } from '../../../../style/Sizes';

const StyledTableWide = styled.table`
  position: absolute;
  left: 12%;
  bottom: 5%;
  width: 560px;
  /* background: silver; */
  text-align: left;

  th {
    font-family: Lato;
    font-weight: 900;
    font-style: normal;
    font-size: 12px;
    letter-spacing: 2px;
  }

  td {
    font-family: Lato;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
  }
`;

const TableSmallContainer = styled.div`
  position: relative;
  margin-left: 12%;
  margin-top: -45%;

  @media ${device.maxMobileL} {
    margin-left: 16px;
  }
`;

const StyledTableSmall = styled.table`
  width: 89vw;
  max-width: 352px;
  /* background: silver; */
  text-align: left;

  th {
    font-family: Lato;
    font-weight: 900;
    font-style: normal;
    font-size: 12px;
    letter-spacing: 2px;
  }

  td {
    font-family: Lato;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    @media (max-width: 359px) {
      font-size: 15px;
    }
  }
`;

const SingleRow = styled.div`
  text-align: left;
  margin-bottom: 11px;
  p {
    display: inline-block;
    font-family: Lato;
    font-weight: 900;
    font-style: normal;
    font-size: 12px;
    letter-spacing: 2px;
  }

  p:first-child {
    margin-left: 3px;
    margin-right: 24px;
  }

  span {
    font-family: Lato;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    letter-spacing: 0;

    @media (max-width: 359px) {
      font-size: 15px;
    }
  }
`;

const TableWide = () => {
  return (
    <StyledTableWide>
      <thead>
        <tr>
          <th>YEAR</th>
          <th>RESPONSIBILITIES</th>
          <th>TOOLS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>2019/20</td>
          <td>UX | Product Design</td>
          <td>Sketch</td>
        </tr>
        <tr>
          <td></td>
          <td>UI Design</td>
          <td>Zeplin</td>
        </tr>
        <tr>
          <th>EMPLOYER</th>
          <td>Prototyping</td>
          <td>Photoshop</td>
        </tr>
        <tr>
          <td>abcfinlab GmbH</td>
          <td>Responsive Web Design</td>
          <td>Illustrator</td>
        </tr>
        <tr>
          <td></td>
          <td>Art Direction</td>
          <td>InDesign</td>
        </tr>
        <tr>
          <td></td>
          <td>Graphic Design</td>
          <td>Jira</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td>Confluence</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </StyledTableWide>
  );
};

const TableSmall = () => {
  return (
    <TableSmallContainer>
      <SingleRow>
        <p>
          YEAR <span>2019/20</span>
        </p>
        <p>
          EMPLOYER <span>abcfinlab GmbH</span>
        </p>
      </SingleRow>
      <StyledTableSmall>
        <thead>
          <tr>
            <th>RESPONSIBILITIES</th>
            <th>TOOLS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>UX | Product Design</td>
            <td>Sketch</td>
          </tr>
          <tr>
            <td>UI Design</td>
            <td>Zeplin</td>
          </tr>
          <tr>
            <td>Prototyping</td>
            <td>Photoshop</td>
          </tr>
          <tr>
            <td>Responsive Web Design</td>
            <td>Illustrator</td>
          </tr>
          <tr>
            <td>Art Direction</td>
            <td>InDesign</td>
          </tr>
          <tr>
            <td>Graphic Design</td>
            <td>Jira</td>
          </tr>
          <tr>
            <td></td>
            <td>Confluence</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </StyledTableSmall>
    </TableSmallContainer>
  );
};

const ClientToolsTable = (props) => {
  
  return <>{props.desktop ? <TableWide /> : <TableSmall />}</>;
};

export default ClientToolsTable;
